import React from "react";
import PropTypes from "prop-types";
import parse from "date-fns/parse";
import format from "date-fns/format";
import addDays from "date-fns/add_days";
import subDays from "date-fns/sub_days";
import getDay from "date-fns/get_day";
import isFirstDayOfMonth from "date-fns/is_first_day_of_month";

import { isoFormat, mondayBefore } from "./helpers";
import Grid from "./Grid";

import "./Calendar.css";

export const Calendar = ({ children, style }) => {
  if (!children) return <Grid />;

  const days =
    children && children.filter
      ? children.filter(child => child.type === Day || child.props.date)
      : [];

  const daysByDate = {};
  let startDate = null;
  let endDate = null;
  days.forEach(day => {
    const date = parse(day.props.date);

    startDate = Math.min(date, startDate || Number.MAX_SAFE_INTEGER);
    endDate = Math.max(date, endDate);

    daysByDate[date] = day;
  });

  // make sure startDate is a Monday
  startDate = mondayBefore(startDate, 1);

  // return <pre>{JSON.stringify({ startDate, endDate }, null, 2)}</pre>;
  // return <pre>{JSON.stringify({ daysByDate }, null, 2)}</pre>;
  const data = [];
  let date = startDate;
  while (date <= endDate) {
    // const day = daysByDate[date];
    // data.push(day ? day.props.children : null);
    data.push(daysByDate[date] || <Day date={date} />);
    date = addDays(date, 1);
  }

  // console.log(children.map(child => child.props.children));
  return (
    <Grid
      style={style}
      cols={7}
      rows={Math.ceil(data.length / 7)}
      data={data}
      headers={["mon", "tue", "wed", "thu", "fri", "sat", "sun"]}
    />
  );
};

Calendar.propTypes = {
  // children: [Day]
};

export const Day = ({ children, date, className }) => {
  // return <pre>{JSON.stringify(props, null, 2)}</pre>;
  let dateLabel = isFirstDayOfMonth(date)
    ? format(date, "MMM D")
    : format(date, "D");

  return (
    <div className={className}>
      <div className="month-day">{dateLabel}</div>
      {children}
    </div>
  );
};
Day.propTypes = {
  // date: PropTypes.date
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.js